
import { useTheme } from "styled-components";

import { useGetBilledOperationOrganisationSummaries } from "@sso/apis/billedOperations/hooks";
import { TableHeader } from "@sso/components/TableHeader";
import { TableLayoutWrapper } from "@sso/components/TableLayoutWrapper";
import { TablePagination } from "@sso/components/TablePagination";
import { TableProvider, TableProviderState } from "@sso/context/tableContext";
import { useAppSelector } from "@sso/hooks/useRedux";
import { selectBilledOperationSummariesPagination } from "@sso/store/slices/billedOperations";
import { CircleLoading } from "@sso/ui/CircleLoading";
import { Flex } from "@sso/ui/FlexBox";
import { Typography } from "@sso/ui/Typography";

import { BilledOperationOrganisationSummaryTable } from "./BilledOperationOrganisationSummaryTable";
import { billedOperationOrganisationSummaryTableColumns } from "./BilledOperationOrganisationSummaryTableColumns";

export const BilledOperationSummary = () => {
    const theme = useTheme();
    const { data, error, isLoading } = useGetBilledOperationOrganisationSummaries();
    const projectPagination = useAppSelector(selectBilledOperationSummariesPagination);

    const tableContextInstance: TableProviderState = { ...projectPagination, columns: billedOperationOrganisationSummaryTableColumns };

    return (
        <>
            {isLoading &&
                <><CircleLoading color={theme.colors.secondary.dark} size={8} />
                    <Flex position="absolute" width="100%" top="55%">
                        <Typography fontWeight="bold">This might take a moment ...</Typography>
                    </Flex>
                </>
            }
            <TableProvider tableInstance={tableContextInstance}>
                <TableHeader title="Organisation Billing Summary" TableActions={<></>} />
                <TableLayoutWrapper error={error} data={data}>
                    {data && <BilledOperationOrganisationSummaryTable summaryList={data.resources} columns={billedOperationOrganisationSummaryTableColumns} />}
                </TableLayoutWrapper>
                <TablePagination totalPages={data?.totalPages} />
            </TableProvider>
        </>
    );
};
